var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 8.43996C5.125 6.47062 5.81324 5.37619 6.60658 4.91779C7.39974 4.4595 8.69203 4.41014 10.3985 5.39478L16.5785 8.95478C18.284 9.93915 18.8875 11.083 18.8875 12C18.8875 12.917 18.2836 14.0611 16.5777 15.0455L10.3977 18.6055C8.69132 19.5902 7.39974 19.5404 6.60658 19.0821C5.81324 18.6237 5.125 17.5293 5.125 15.56V8.43996Z",
    fill: "#0F1653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBig);
export default __webpack_public_path__ + "static/media/play-big.2f3700899d618ca16662df4da5820107.svg";
export { ForwardRef as ReactComponent };